// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"Login_loginForm__vjRVb","centered":"Login_centered__1GG3_","forgotPassword":"Login_forgotPassword__K1mY9"};